import * as React from "react"

import { Selector, ItemBlockPart } from "@tenforce/toolbox-selector-react"

import { ChartComponent } from "./ChartComponent"
import { IIndicator } from "../../index"

type Props = IIndicator

const ChartIndicator = ({
    chartData,
    color,
    description,
    id,
    showLabels,
    title,
    url,
    value,
}: Props): JSX.Element => {
    let colorCode = "#cccccc"
    if (color === "green") {
        colorCode = "#30ff00"
    } else if (color === "yellow") {
        colorCode = "#ffe600"
    } else if (color === "red") {
        colorCode = "#ff3232"
    }

    return (
        <article
            className="tw-w-full lg:tw-w-1/4"
            data-ft-component="indicatorCard"
            data-ft-description={description}
            data-ft-indicator-id={id}
            data-ft-indicator-type="chart"
            data-ft-title={title}
            data-ft-value={value}
            title={description}
        >
            <div className="tw-p-2 full-size">
                <a
                    href={url}
                    className="theme-card-link bg-cloud tw-block full-size text-black tw-px-4 tw-pt-1 tw-overflow-hidden"
                    data-ft-component="indicatorLink"
                >
                    <div className="tw-flex tw-items-center tw-mb-2">
                        <div
                            className="h4 tw-flex-1 tw-py-2"
                            dangerouslySetInnerHTML={{
                                __html: title,
                            }}
                        />
                        <Selector
                            isReadOnly={true}
                            isExpanded={false}
                            title={`${value}`}
                        >
                            <ItemBlockPart
                                isSelected={true}
                                partProps={{
                                    extraClasses: "h5",
                                    color: colorCode,
                                }}
                            >
                                {value}
                            </ItemBlockPart>
                        </Selector>
                    </div>
                    <ChartComponent
                        chartData={chartData}
                        showLabels={showLabels}
                    />
                </a>
            </div>
        </article>
    )
}

export default ChartIndicator
